import { Component, Output, EventEmitter, DoCheck } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { SagawaEhidenService } from '../../../service/sagawa-ehiden/sagawa-ehiden.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';

@Component({
  selector: 'wa3922',
  templateUrl: 'wa3922.component.html',
  styleUrls: ['wa3922.component.scss']
})
export class Wa3922Component {
  public componentTitle = 'WA3922:e飛伝　問い合わせNo取込';


  private uploader: FileUploader;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  @Output()
  private errorout = new EventEmitter();

  private errorInfo = '';
  private isShowSendLoading = false;
  private isSubmitButtonEnabled = false;

  private hasBaseDropZoneOver: boolean;
  private hasAnotherDropZoneOver: boolean;

  constructor(private sagawaEhidenService: SagawaEhidenService, private commonService: CommonService, ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }

    this.uploader = new FileUploader({
      disableMultipart: true
    });
    this.hasBaseDropZoneOver = false;
    this.hasAnotherDropZoneOver = false;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;

    if (this.uploader.queue.length > 1) {
      this.errorInfo = 'ファイルアップロードは、1ファイルのみ可能です。ファイル選択を初期化します。再度、選び直してください。';
      this.hasBaseDropZoneOver = false;
      this.hasAnotherDropZoneOver = false;
      this.uploader.clearQueue();
    } else {
      this.errorInfo;
    }
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  fileChange(event) {
    console.log(' ===== teset')
    this.errorInfo = '';
    this.errorout.emit(this.errorInfo);
    const fileList: FileList = event.target.files;

    console.log(this.uploader)
  }

  upload() {
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.isShowSendLoading = true;
    this.errorInfo = '';
    this.errorout.emit(this.errorInfo);
    if (this.uploader.queue.length == 0) {
      this.errorInfo = 'ファイルを選択してください';
      this.errorout.emit(this.errorInfo);
      this.working = false;
      this.isShowSendLoading = false;      
      return;
    }
    console.log(this.uploader.queue.length)
    this.sagawaEhidenService
      .upload(this.uploader.queue[0]._file)
      .then(outputJson => {
        this.working = false;
        this.isShowSendLoading = false;
        this.uploader.queue.length = 0;
        this.errorInfo = '完了', 'アップロードが完了しました。';
        this.errorout.emit(this.errorInfo);
        this.isSubmitButtonEnabled = false;
      })
      .catch(error => {
        this.working = false;
        this.isShowSendLoading = false;
        this.uploader.queue.length = 0;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.errorout.emit(this.errorInfo);
        this.isSubmitButtonEnabled = false;
      });
  }

  onDeleteAttachment() {
    this.uploader.queue.length = 0;
    let inputElement = <HTMLInputElement>document.getElementById('upload');
    inputElement.value = null;
    this.uploader = new FileUploader({
      disableMultipart: true
    });
  }

  ngDoCheck() {
    this.isSubmitButtonEnabled = this.uploader.queue.length > 0;
  }

  Changes() {
    // if (this.uploader.queue.length > 0) {
    //   var file = JSON.stringify(this.uploader.queue[0].file)
    //   this.file = JSON.parse(file);
    // }
  }

  FileDrop(e) {
    this.Changes();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa3Shipment/wa3922/wa3922.component.ts